// The `(((...)))` wrapper is load-bearing, not cosmetic: the advanced-editor apply path find-and-replaces
// `(((uid.*?)))`, so a programmatic apply swaps its own prior clause instead of appending a second one.
// `uid` resolves as a numeric schema variable, so values are unquoted decimals; `uid in <single>` has no
// grammar production, which is why one uid has to emit `uid = x`.
// A filter with no status clause falls back to completed-only, so a pinned respondent outside that scope
// would drop out; the uids already fix the set, so widening the status cannot add anyone.
export const PINNED_STATUS_CLAUSE = " and status in 'completed', 'excessive', 'dc-auto-rejected'"

export const calcUidFilter = (uids, suffix = '') =>
  1 == uids.length ? `(((uid = ${uids[0]}${suffix})))` : `(((uid in ${uids.join(',')}${suffix})))`

export default calcUidFilter
